<template>
  <div>
    <NuxtRouteAnnouncer />
    <NuxtLayout>
      <ClientOnly>
        <ErrorPopup />
        <ToastNotification />
        <NuxtPage />
        <template #fallback>
          <div class="loading-placeholder">Loading...</div>
        </template>
      </ClientOnly>
    </NuxtLayout>
  </div>
</template>

<script setup>
// Global SEO defaults and structured data
useHead({
  meta: [
    { name: 'google-adsense-account', content: 'ca-pub-5988234558674670' },
    { name: 'application-name', content: 'Tuck' },
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'default' },
    { name: 'apple-mobile-web-app-title', content: 'Tuck Budget Wizard' },
    { name: 'format-detection', content: 'telephone=no' },
    { name: 'mobile-web-app-capable', content: 'yes' },
    { name: 'msapplication-TileColor', content: '#4a90e2' },
    { name: 'msapplication-tap-highlight', content: 'no' },
    { name: 'theme-color', content: '#4a90e2' },
    { name: 'google-site-verification', content: 'YOUR_GOOGLE_SITE_VERIFICATION' },
    { name: 'yandex-verification', content: 'YOUR_YANDEX_VERIFICATION' },
    { name: 'msvalidate.01', content: 'YOUR_BING_VERIFICATION' }
  ],
  htmlAttrs: {
    lang: 'en-GB'
  },
  link: [
    { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
    { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: '' },
    { rel: 'dns-prefetch', href: 'https://www.tuck.cash' },
    { rel: 'manifest', href: '/manifest.json' },
    { rel: 'apple-touch-icon', href: '/icons/apple-touch-icon.png' },
    { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/icons/favicon-32x32.png' },
    { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/icons/favicon-16x16.png' },
    { rel: 'mask-icon', href: '/icons/safari-pinned-tab.svg', color: '#4a90e2' },
    { rel: 'shortcut icon', href: '/favicon.ico' }
  ],
  script: [
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Tuck',
        url: 'https://www.tuck.cash',
        logo: 'https://www.tuck.cash/logo.png',
        description: 'UK personal budgeting application helping users achieve financial freedom through smart budget planning, debt management, and investment tracking.',
        foundingDate: '2024',
        areaServed: 'United Kingdom',
        hasOfferCatalog: {
          '@type': 'OfferCatalog',
          name: 'Personal Finance Tools',
          itemListElement: [
            {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'SoftwareApplication',
                name: '11-Step Budget Wizard',
                applicationCategory: 'FinanceApplication'
              }
            },
            {
              '@type': 'Offer', 
              itemOffered: {
                '@type': 'SoftwareApplication',
                name: 'Debt Freedom Planner',
                applicationCategory: 'FinanceApplication'
              }
            },
            {
              '@type': 'Offer',
              itemOffered: {
                '@type': 'SoftwareApplication', 
                name: 'Investment Portfolio Tracker',
                applicationCategory: 'FinanceApplication'
              }
            }
          ]
        },
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '',
          contactType: 'customer service',
          email: 'support@tuck.cash',
          availableLanguage: ['English']
        },
        sameAs: [
          'https://twitter.com/tuckdotcash',
          'https://www.linkedin.com/company/tuck-cash',
          'https://www.facebook.com/tuckdotcash'
        ]
      })
    }
  ]
});

// No need to import or instantiate the useErrorPopup composable here
// since the ErrorPopup component will use it
</script>

<style>
.loading-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 1.2rem;
  color: var(--color-text-secondary);
}
</style>
